export const sources={webp:"__VITE_ASSET__wtqJU8EI__ 30w"};export const img={src:"__VITE_ASSET__ByCtswUN__",w:30,h:30};export default{sources:sources,img:img};